import { Injectable, NgZone } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class NgZoneInterceptor implements HttpInterceptor {
  constructor(private ngZone: NgZone) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return new Observable(observer => {
      next.handle(req).subscribe({
        next: val => this.ngZone.run(() => observer.next(val)),
        error: err => this.ngZone.run(() => observer.error(err)),
        complete: () => this.ngZone.run(() => observer.complete()),
      });
    });
  }
}
